app.service('storageService', ['$window', function ($window) {
  const storageService = this;
  let fake_storage = {};

  storageService.isLocalStorageSupported = function () {
    try {
      const storage = $window.localStorage;
      return !!storage.getItem;
    }
    catch (e) {
      return false;
    }
  };

  storageService.getLocalStorage = function () {
    if (storageService.isLocalStorageSupported()) {
      return $window.localStorage;
    } else {
      return fake_storage;
    }
  };

  storageService.clearLocalStorage = function () {
    if (!storageService.isLocalStorageSupported()) {
      fake_storage = {};
      return;
    }

    const storage = storageService.getLocalStorage();

    for (const key in storage) {
      if (typeof storage[key] !== 'object' && typeof storage[key] !== 'string') {
        continue;
      }

      if (key == 'testApiServer') {
        continue;
      }

      try {
        const object = JSON.parse(storage[key]);

        // check if object not yet expired
        if ('expires_on' in object && new Date(object['expires_on']) > new Date()) {
          continue;
        }
      }
      catch (e) {
        // it fails on any error
      }

      delete storage[key];
    }
  };
}]);
